export default "__VITE_ASSET__d1c7c158__"